var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingtoVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8 9.794 9.794 8 12 8C14.206 8 16 9.794 16 12C16 14.206 14.206 16 12 16C9.794 16 8 14.206 8 12ZM9.33333 12C9.33333 13.4707 10.5293 14.6667 12 14.6667C13.4707 14.6667 14.6667 13.4707 14.6667 12C14.6667 10.5293 13.4707 9.33333 12 9.33333C10.5293 9.33333 9.33333 10.5293 9.33333 12ZM12.1953 13.138C12.3253 13.268 12.496 13.3333 12.6667 13.3333C12.8373 13.3333 13.008 13.268 13.138 13.138C13.3987 12.8773 13.3987 12.456 13.138 12.1953L12.6667 11.724V10.6667C12.6667 10.298 12.368 10 12 10C11.632 10 11.3333 10.298 11.3333 10.6667V12C11.3333 12.1773 11.4033 12.3467 11.5287 12.4713L12.1953 13.138Z",
    fill: "#404651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 7.33333V4.66667H10V6.226L8.92733 7.33333H8.66667ZM7.374 14.6347C3.99067 14.318 1.33333 11.464 1.33333 8C1.33333 4.324 4.324 1.33333 8 1.33333C11.4007 1.33333 14.21 3.89533 14.612 7.18933C15.0533 7.58133 15.5353 8.03533 15.9713 8.56267C15.9847 8.376 16 8.19 16 8C16 3.58867 12.4113 0 8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C8.158 16 8.312 15.9853 8.46733 15.976C8.03467 15.592 7.664 15.14 7.374 14.6347ZM4.66667 7.33333V4.66667H3.33333V7.33333H4.66667ZM7.33333 7.33333V4.66667H6V7.33333H7.33333Z",
    fill: "#404651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingtoVerify);
export default __webpack_public_path__ + "static/media/Pending to Verify.3ebae949aaae669b1cee10c47ee0b862.svg";
export { ForwardRef as ReactComponent };